var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('PremiumFeatureGate', {
    attrs: {
      "required-subscription": "premium",
      "value": _vm.value,
      "inline": _vm.inline
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('p', {
    staticClass: "text-body-2 text--secondary mb-4 max-width-lg mx-auto premium-gate-content-intro"
  }, [_vm._v(" " + _vm._s(_vm.$translate('warehousesPremiumIntro')) + " ")]), _c('ul', {
    staticClass: "premium-gate-bullets"
  }, [_c('li', [_c('span', {
    staticClass: "premium-gate-bullet-icon"
  }, [_c('v-icon', {
    attrs: {
      "size": "16",
      "color": "white"
    }
  }, [_vm._v("mdi-check")])], 1), _c('span', [_vm._v(_vm._s(_vm.$translate('warehousesPremiumBullet1')))])]), _c('li', [_c('span', {
    staticClass: "premium-gate-bullet-icon"
  }, [_c('v-icon', {
    attrs: {
      "size": "16",
      "color": "white"
    }
  }, [_vm._v("mdi-check")])], 1), _c('span', [_vm._v(_vm._s(_vm.$translate('warehousesPremiumBullet2')))])]), _c('li', [_c('span', {
    staticClass: "premium-gate-bullet-icon"
  }, [_c('v-icon', {
    attrs: {
      "size": "16",
      "color": "white"
    }
  }, [_vm._v("mdi-check")])], 1), _c('span', [_vm._v(_vm._s(_vm.$translate('warehousesPremiumBullet3')))])])])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }